import { render } from "./LabelText.vue?vue&type=template&id=1a2cd354"
import script from "./LabelText.vue?vue&type=script&lang=js"
export * from "./LabelText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__